<template>
  <div class="login-view" :class="configStore.electronMode ? 'white-backgroup' : ''">
    <div class="decoration decoration-1"></div>
    <div class="decoration decoration-2"></div>
    <div class="decoration decoration-3"></div>
    <div class="content">
      <!-- 密码登录表单 -->
      <el-form
        v-if="loginMode === 'password'"
        class="form"
        :model="loginForm"
        status-icon
        :rules="rules"
        ref="loginForm"
        v-loading="loading"
        element-loading-text="正在登陆..."
      >
        <div class="title">登录得信聊天</div>
        <el-form-item prop="terminal" v-show="false">
          <el-input type="terminal" v-model="loginForm.terminal"></el-input>
        </el-form-item>
        <el-form-item prop="userName">
          <!-- 这里输入后失去焦点要自动拉取一次onRefreshCaptcha -->
          <el-input
            type="userName"
            v-model="loginForm.userName"
            :placeholder="loginNamePlaceholder"
            prefix-icon="el-icon-user"
            @blur="onRefreshCaptcha"
          ></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="loginForm.password"
            placeholder="密码"
            prefix-icon="el-icon-lock"
          ></el-input>
        </el-form-item>
        <!-- 图形验证码 -->
        <el-form-item prop="captchaCode">
          <div style="display:flex;align-items:center;gap:10px;width:100%;">
            <el-input
              v-model="loginForm.captchaCode"
              placeholder="请输入图形码"
              prefix-icon="el-icon-picture-outline"
            />
            <img
              v-if="captchaImage"
              :src="captchaImage"
              @click="onRefreshCaptcha"
              style="height:40px;width:100px;cursor:pointer;border-radius:4px;border:1px solid #ddd;"
            />
            <el-button size="mini" @click="onRefreshCaptcha">刷新图形码</el-button>
          </div>
        </el-form-item>

        <el-form-item>
          <div class="nav-tool-bar">
            <el-checkbox v-model="isAutoLogin">下次自动登录</el-checkbox>
            <router-link
              v-if="containsPhoneMode || containsEmailMode"
              class="forgot-pwd"
              to="/password/reset"
            >
              忘记密码?
            </router-link>
            <router-link to="/register">没有账号? 立即注册</router-link>
          </div>
        </el-form-item>
        <el-button class="submit-btn" type="primary" @click="submitForm()">登录</el-button>
        <div class="qr-switch-btn" type="success" @click="toggleLoginMode">
          <i class="iconfont icon-scan"></i>
          扫码登录
        </div>
      </el-form>

      <!-- 扫码登录界面 -->
      <QrLogin v-if="loginMode === 'qr'" @back="goBackToPassword" />
    </div>
    <icp></icp>
    <captcha-image ref="captchaRef"></captcha-image>
  </div>
</template>

<script>
import Icp from "../components/common/Icp.vue";
import CaptchaImage from "../components/common/CaptchaImage.vue";
import QrLogin from "../components/login/QrLogin.vue";

export default {
  name: "login",
  components: {
    Icp,
    CaptchaImage,
    QrLogin,
  },
  data() {
    const checkRequired =
      (msg) =>
      (rule, val, cb) => {
        if (!val) return cb(new Error(msg));
        cb();
      };
    const checkUsername = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入用户名"));
      }
      callback();
    };
    const checkPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      }
      callback();
    };
    return {
      loading: false,
      isAutoLogin: true,
      captchaImage: "",
      loginForm: {
        terminal: this.$enums.TERMINAL_TYPE.WEB,
        userName: "",
        password: "",
        captchaCode: "",
        captchaId: "",
        captchaImage: "",
      },
      rules: {
        userName: [
          {
            validator: checkUsername,
            trigger: "blur",
          },
        ],
        password: [
          {
            validator: checkPassword,
            trigger: "blur",
          },
        ],
        captcha: [{ validator: checkRequired("请输入图形验证码"), trigger: "blur" }],
      },
      // 登录模式切换
      loginMode: "password", // password, qr
    };
  },
  computed: {
    loginNamePlaceholder() {
      let mode = this.configStore.registration.mode;
      let strText = "用户名";
      if (mode.includes("phone")) {
        strText += "/手机号";
      }
      if (mode.includes("email")) {
        strText += "/邮箱";
      }
      return strText;
    },
    containsPhoneMode() {
      return this.modes.includes("phone");
    },
    containsEmailMode() {
      return this.modes.includes("email");
    },
    modes() {
      return this.configStore.registration.mode || [];
    },
  },
  methods: {
    // 刷新图形验证码
    onRefreshCaptcha() {
      if (!this.loginForm.userName.trim()) {
        this.$message.warning("请先输入用户名再获取验证码");
        return;
      }
      this.$http({
        url: "/captcha/img/code?tag=" + encodeURIComponent(this.loginForm.userName),
        method: "POST",
      })
        .then((res) => {
          this.loginForm.captchaId = res.id;
          this.captchaImage = "data:image/gif;base64," + res.image;
        })
        .catch((err) => {
          console.error("刷新验证码失败：", err);
        });
    },

    submitForm() {
      console.log("手动登录 submitForm()");
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.$http({
            url: "/login",
            method: "post",
            data: this.loginForm,
          })
            .then((data) => {
              localStorage.setItem("isAutoLogin", this.isAutoLogin);
              localStorage.setItem("username", this.loginForm.userName);
              localStorage.setItem("password", this.loginForm.password);

              sessionStorage.setItem("accessToken", data.accessToken);
              sessionStorage.setItem("refreshToken", data.refreshToken);

               // 只新增这里
              if (this.isAutoLogin) {
                localStorage.setItem("autoAccessToken", data.accessToken);
                localStorage.setItem("autoRefreshToken", data.refreshToken);
              } else {
                localStorage.removeItem("autoAccessToken");
                localStorage.removeItem("autoRefreshToken");
              }


              // 若有第三方退出标记，这里可以清除
              localStorage.removeItem("thirdGlobalDisabled");

              this.$message.success("登录成功");

              this.$router.push("/home/chat");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 登录模式切换
    toggleLoginMode() {
      if (this.loginMode === "password") {
        this.loginMode = "qr";
      } else {
        this.loginMode = "password";
      }
    },
    goBackToPassword() {
      this.loginMode = "password";
    },
  },
  mounted() {
    console.log("mounted - 第三方登录检查");

    /**
     * 与手机版保持一致的第三方入口参数读取方式：
     *
     * 1. https://dx.p985.com/h5/?customerId=4&deviceId=...&authType=ds28
     * 2. #/login?customerId=4&deviceId=...&authType=ds28
     * 3. Vue Router this.$route.query
     *
     * customerId 必须原样带到聊天页：
     * 1 = 商务
     * 3 = 代理
     * 4 = 客服
     *
     * 不能使用上一次 activeChat / 旧会话下标代替 customerId。
     */
    const href = window.location.href || "";

    const beforeHashQuery = href.includes("?")
      ? href.split("?")[1].split("#")[0]
      : "";
    const beforeHashParams = new URLSearchParams(beforeHashQuery);

    const hashText = href.includes("#") ? href.split("#")[1] : "";
    const hashQuery = hashText.includes("?") ? hashText.split("?")[1] : "";
    const hashParams = new URLSearchParams(hashQuery);

    const routeQuery = this.$route.query || {};

    const readEntryParam = (name) => {
      const fromUrl = beforeHashParams.get(name);
      if (fromUrl !== null && fromUrl !== "") return fromUrl;

      const fromHash = hashParams.get(name);
      if (fromHash !== null && fromHash !== "") return fromHash;

      const fromRoute = routeQuery[name];
      if (
        fromRoute !== undefined &&
        fromRoute !== null &&
        String(fromRoute) !== ""
      ) {
        return String(fromRoute);
      }

      return null;
    };

    const thirdToken = readEntryParam("thirdToken");
    let authType = readEntryParam("authType");
    const customerId = readEntryParam("customerId");
    const deviceId = readEntryParam("deviceId");

    // 与手机版一致：customerId=1 历史入口缺 authType 时默认 ds28。
    if (String(customerId || "") === "1" && !authType) {
      authType = "ds28";
    }

    if (customerId && authType) {
      const fixedCustomerId = String(customerId);

      console.log("[THIRD_CHAT][PC] login entry params =>", {
        customerId: fixedCustomerId,
        authType,
        hasThirdToken: !!thirdToken,
        deviceId,
      });

      /**
       * 关键：
       * 每次第三方入口都必须立刻把固定聊天目标覆盖成“本次 customerId”。
       *
       * 例如上一次 customerId=4，sessionStorage 里可能还留着 4；
       * 现在重新访问 customerId=3 时必须先改成 3，
       * 否则 Home 拉离线消息时，旧的 4 会再次把代理窗口覆盖成客服窗口。
       */
      sessionStorage.setItem("thirdFixedCustomerId", fixedCustomerId);

      /**
       * 同一个 IM 域、同一个咨询窗口内，如果已经有 accessToken，
       * 就直接复用现有登录态，不再重复请求 /open/token。
       *
       * token 过期仍交给项目原有 httpRequest 的 401 / refreshToken 逻辑处理。
       */
      const existingAccessToken = sessionStorage.getItem("accessToken");

      if (existingAccessToken) {
        console.log("[THIRD_CHAT][PC] reuse existing IM accessToken =>", {
          customerId: fixedCustomerId,
        });

        localStorage.removeItem("thirdGlobalDisabled");

        this.$router.replace({
          path: "/home/chat",
          query: {
            customerId: fixedCustomerId,
            fromThird: "1",
          },
        });

        return;
      }

      this.loading = true;

      /**
       * 当前 IM 域第一次进入、没有 accessToken 时才调用 /open/token。
       * deviceId / thirdToken 有值才传，customerId 原样传递。
       */
      const params = {
        customerId: fixedCustomerId,
        authType: String(authType),
      };

      if (deviceId) {
        params.deviceId = String(deviceId);
      }

      if (thirdToken) {
        params.thirdToken = String(thirdToken);
      }

      this.$http({
        url: "/open/token",
        method: "get",
        params,
      })
        .then((data) => {
          sessionStorage.setItem("accessToken", data.accessToken);
          sessionStorage.setItem("refreshToken", data.refreshToken);

          localStorage.removeItem("thirdGlobalDisabled");

          /**
           * 不再先跳 Friend.vue，也不依赖上一次 activeChat。
           * 直接把本次 customerId 带到 Chat.vue，
           * 由 Chat.vue 按 PRIVATE targetId === customerId 精确定位。
           */
          this.$router.replace({
            path: "/home/chat",
            query: {
              customerId: fixedCustomerId,
              fromThird: "1",
            },
          });
        })
        .catch((err) => {
          sessionStorage.removeItem("thirdFixedCustomerId");
          console.error("[THIRD_CHAT][PC] 自动登录失败 =>", err);
        })
        .finally(() => {
          this.loading = false;
        });

      return;
    }

    // 恢复上次输入
    this.loginForm.userName = localStorage.getItem("username") || "";
    this.loginForm.password = localStorage.getItem("password") || "";



    // electron 窗口
    this.configStore.loadConfig();
    window.electronAPI &&
      window.electronAPI.sendEvent("resize", {
        width: 410,
        height: 510,
        maximizable: false,
      });

    // 自动登录逻辑
    const auto = localStorage.getItem("isAutoLogin");
    if (auto === "true") {
      this.isAutoLogin = true;
      const autoAccessToken =
        localStorage.getItem("autoAccessToken");

      const autoRefreshToken =
        localStorage.getItem("autoRefreshToken");

      // 上次勾选了自动登录，并且已有登录 token
      if (autoAccessToken && autoRefreshToken) {
        sessionStorage.setItem(
          "accessToken",
          autoAccessToken
        );

        sessionStorage.setItem(
          "refreshToken",
          autoRefreshToken
        );

        console.log("自动登录成功");

        this.$router.replace("/home/chat");

        return;
      }
    } else {
      this.isAutoLogin = false;

      // 没勾选，则不允许下次自动登录
      localStorage.removeItem("autoAccessToken");
      localStorage.removeItem("autoRefreshToken");
    }
  },
};
</script>

<style scoped lang="scss">
.login-noDisplay {
  display: none;
  opacity: 0;
}
.login-view {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  background: linear-gradient(
    135deg,
    #87adeb 0%,
    #8287ec 25%,
    #87adeb 50%,
    #898ee3 75%,
    #87adeb 100%
  );

  &.white-backgroup {
    background: white;
  }

  /* 装饰性元素 */
  .decoration {
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.2);
  }

  .decoration-1 {
    width: 450px;
    height: 450px;
    background: linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(200, 220, 240, 0.4) 100%
    );
    top: -250px;
    right: -100px;
    animation: float 16s infinite ease-in-out;
  }

  .decoration-2 {
    width: 400px;
    height: 400px;
    background: linear-gradient(
      135deg,
      rgba(200, 220, 240, 0.4) 0%,
      rgba(255, 255, 255, 0.3) 100%
    );
    bottom: -200px;
    left: -100px;
    animation: float 12s infinite ease-in-out;
  }

  .decoration-3 {
    width: 300px;
    height: 300px;
    background: linear-gradient(
      45deg,
      rgba(161, 196, 253, 0.3) 0%,
      rgba(194, 233, 251, 0.4) 100%
    );
    top: 50%;
    right: 50px;
    animation: float 8s infinite ease-in-out;
  }

  @keyframes float {
    0%,
    100% {
      transform: translateY(0) translateX(0);
    }

    25% {
      transform: translateY(-60px) translateX(30px);
    }

    50% {
      transform: translateY(30px) translateX(-45px);
    }

    75% {
      transform: translateY(-30px) translateX(-30px);
    }
  }

  .content {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    .form {
      width: 360px;
      height: 460px;
      padding: 25px;
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(8px);
      border-radius: 3%;
      overflow: hidden;

      // 优化输入框样式
      ::v-deep .el-form-item {
        margin-bottom: 20px;

        .el-input__inner {
          height: 50px;
          border-radius: 25px;
          border: 2px solid transparent;
          background: rgba(255, 255, 255, 0.9);
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
          padding-left: 50px;
          font-size: var(--im-font-size-large);

          &:focus {
            border-color: var(--im-color-primary);
            box-shadow: 0 8px 32px rgba(62, 69, 215, 0.15);
            transform: translateY(-2px);
          }

          &::placeholder {
            color: var(--im-text-color-light);
            font-size: var(--im-font-size);
          }
        }

        .el-input__prefix {
          left: 15px;

          .el-input__icon {
            color: var(--im-color-primary);
            font-size: 18px;
          }
        }

        .el-input__suffix {
          display: none;
        }
      }

      .title {
        line-height: 50px;
        margin: 30px 0;
        font-size: 24px;
        font-weight: 700;
        color: var(--im-color-primary);
        letter-spacing: 1px;
        text-align: center;
      }

      .submit-btn {
        width: 100%;
        height: 46px;
        border-radius: 23px;
        border: none;
        background: linear-gradient(135deg, var(--im-color-primary), #5a61e8);
        color: white;
        font-size: var(--im-font-size-large);
        font-weight: 600;
        box-shadow: 0 8px 16px rgba(62, 69, 215, 0.3);
        transition: all 0.3s ease;
        letter-spacing: 5px;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 40px rgba(62, 69, 215, 0.4);
        }

        &:active {
          transform: translateY(1px);
          box-shadow: 0 4px 16px rgba(62, 69, 215, 0.4);
        }
      }

      .qr-switch-btn {
        width: 100%;
        margin-top: 10px;
        margin-left: 0;
        height: 46px;
        border-radius: 23px;
        border: 2px solid var(--im-color-primary);
        background: transparent;
        color: var(--im-color-primary);
        font-size: var(--im-font-size-large);
        font-weight: 600;
        box-shadow: none;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-sizing: border-box;

        &:hover {
          background: var(--im-color-primary);
          color: white;
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(62, 69, 215, 0.3);
        }

        &:active {
          transform: translateY(1px);
          box-shadow: 0 4px 16px rgba(62, 69, 215, 0.3);
        }

        i {
          margin-right: 6px;
          font-size: 18px;
        }
      }

      .nav-tool-bar {
        display: flex;
        justify-content: space-between;

        .forgot-pwd {
          text-decoration: none;
          color: #6a6a6a;
          font-size: var(--im-font-size-small);
          transition: all 0.3s ease;

          &:hover {
            color: var(--im-color-primary);
          }
        }
      }

      .register {
        display: flex;
        flex-direction: row-reverse;
        line-height: 40px;
        text-align: left;
        margin-top: 20px;
        padding-left: 20px;

        a {
          color: #6a6a6a;
          text-decoration: none;
          font-size: var(--im-font-size);
          transition: all 0.3s ease;

          &:hover {
            color: var(--im-color-primary);
          }
        }
      }
    }
  }
}
</style>
